export const CAROUSEL_REQUEST = "@@listMovieHomepageReducer/CAROUSEL_REQUEST";
export const CAROUSEL_SUCCESS ="@@listMovieHomepageReducer/CAROUSEL_SUCCESS";
export const CAROUSEL_FAIL="@@listMovieHomepageReducer/CAROUSEL_FAIL";